export default function isUrl(str) {
  return RegExp('^(http:|https:|//)+').test(str)
}
